<template>
<div class="chapter">
<div class="inner_page">
<h1 class="TITLE">Hooked!</h1>
<h2 class="SUBTITLE">40 Whimsical crochet motifs<br/>from weird to wonderful</h2>
<h2 class="AUTHOR">MICHELLE, CÉCILE<br/>&amp; SYLVIE DELPRAT</h2>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
<p class="pub"><a href="http://www.stitchcraftcreate.co.uk" target="_blank">www.stitchcraftcreate.co.uk</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?3fc20e9c